export class ArrayUtils {

  public static of(count: number): number[] {
    return new Array(count);
  }

}
